class TextAnimation {
    constructor(element, options) {
        // Default options
        const defaults = {
            initAttr: 'data-textanimation',
        };

        // Settings
        this.settings = Object.assign({}, defaults, options);
        this.isAnimated = false;

        this.$textAnimation = element;
    }

    initialize() {
        this.setEvents();
    }

    prepareWords(element) {
        const fragment = document.createDocumentFragment();

        Array.from(element.childNodes).forEach((node) => {
            if (node.nodeType === 3) {
                const text = node.textContent.trim();
                if (text.length > 0) {
                    const words = text.split(' ');
                    words.forEach((word) => {
                        const span = document.createElement('span');
                        span.classList.add('researchAiLandingpage-textanimation__word');
                        span.textContent = `${ word } `;
                        fragment.appendChild(span);
                    });
                }
            } else if (node.nodeType === 1 && node.tagName === 'SPAN') {
                const existingSpan = node.cloneNode(true);
                this.prepareWords(existingSpan);
                fragment.appendChild(existingSpan);
            }
        });

        element.textContent = '';
        element.appendChild(fragment);
    }

    initAnimation() {
        if (window.innerWidth >= 768) {
            this.prepareWords(this.$textAnimation);
            this.addAnimation();
        }
    }

    addAnimation() {
        const $$spans = this.$textAnimation.querySelectorAll('.researchAiLandingpage-textanimation__word');

        if ($$spans.length > 0) {
            $$spans.forEach(($span, index) => {
                $span.style.animationDelay = `${ (index + 1) * 0.15 }s`;
            });
        }
    }

    setEvents() {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    if (!this.isAnimated) {
                        this.initAnimation();
                        this.isAnimated = true;
                        observer.unobserve(entry.target);
                    }
                }
            });
        }, { threshold: 0.1 });

        observer.observe(this.$textAnimation);
    }
}

export { TextAnimation };
